module.exports = __webpack_public_path__ + "static/img/logo2.d6b20cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/logo2.png
// module id = hqui
// module chunks = 24